export default __webpack_public_path__ + "static/22-26 Vaishnav et al-c4f4fcc6fecfd2610fd901c0fc2ccde2.pdf";